import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";

export default function FullScreenLoadingIndicator({ loading: isLoading }) {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isLoading) {
      setLoading(true);
    } else {
      const timeout = setTimeout(() => {
        setLoading(false);
      }, 500);
      return () => clearTimeout(timeout);
    }
  }, [isLoading]);

  return (
    loading && (
      <div
        className="position-fixed top-0 start-0 vh-100 w-100 text-bg-light bg-opacity-50"
        style={{ zIndex: 10000 }}
      >
        <div className="position-fixed top-50 start-50 translate-middle text-primary">
          <FontAwesomeIcon icon={faSpinner} spin size="5x" />
        </div>
      </div>
    )
  );
}

export function AbsoluteLoadingIndicator({ loading: isLoading }) {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isLoading) {
      setLoading(true);
    } else {
      const timeout = setTimeout(() => {
        setLoading(false);
      }, 500);
      return () => clearTimeout(timeout);
    }
  }, [isLoading]);

  return (
    loading && (
      <div
        className="position-absolute p-0 start-0 h-100 w-100 text-bg-light bg-opacity-50 z-1 overflow-auto"
        // This is to prevent scrolling
        style={{ overscrollBehavior: "contain", scrollbarWidth: "none" }}
      >
        <div style={{ height: "calc(100% + 1px)" }} />
        <div className="position-absolute top-50 start-50 translate-middle text-primary z-1">
          <FontAwesomeIcon icon={faSpinner} spin size="5x" />
        </div>
      </div>
    )
  );
}
